import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/area-chart/pages/CalculatorPage";

export const Route = createFileRoute("/area-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/area-chart",
      title: m.area_meta_title(),
      description: m.area_meta_description(),
      toolName: m.area_tool_name(),
      faqs: [
        { q: m.area_faq_q1(), a: m.area_faq_a1() },
        { q: m.area_faq_q2(), a: m.area_faq_a2() },
        { q: m.area_faq_q3(), a: m.area_faq_a3() },
        { q: m.area_faq_q4(), a: m.area_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
